<div id="landing_aceptacion-encuesta" class="container">
  <div class="wrapped-card rounded-lg">
    <div class="row g-0">
      <div
        class="col-12 col-lg-6 d-flex flex-column justify-content-center align-content-center order-2 order-xl-1 p-3">
        <h2 class="text-uppercase text-center title">
          ¡Gracias!
        </h2>
        <h3 class="text-center title_2">Hemos registrado correctamente tus respuestas</h3>
        <div class="row justify-content-md-center mt-lg-3">
          <div class="col-12">
            <a routerLink="/microempresario/home" class="btn btn-primary hvr-shrink w-100">
              Aceptar
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 order-1 order-xl-2">
        <img src="assets/img/aceptacionEncuesta.jpg" alt="Secure" class="img-fluid">
      </div>
    </div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</div>
